// color.js

export const TEXTPRIMARY = "primay-color"; // Primary text color
export const TEXTSECONDARY = "secondary-color"; // Secondary text color
export const TEXTTERTIARY = "tertiary-color"; // Tertiary text color
export const LINKCOLOR = "link-color"; // Link color
export const FONTCOLOR = "font-color"; // General font color
